import { render } from "./SmallPagination.vue?vue&type=template&id=1383ecf9"
import script from "./SmallPagination.vue?vue&type=script&lang=js"
export * from "./SmallPagination.vue?vue&type=script&lang=js"
script.render = render

export default script